import { LineItem } from '@business/entities/project/SubscriptionResponse';
import { WithTooltip } from '@modules/common';
import React, { memo, useMemo, Fragment } from 'react';
interface InvoiceLineTooltipProps {
  lineItems: LineItem[];
  title: string;
}

export const InvoiceLineTooltip = memo((props: InvoiceLineTooltipProps) => {
  const { lineItems, title } = props;
  const items = useMemo(() => {
    if (!lineItems) return '';
    return (
      <div>
        {lineItems.map((item, index) => {
          return (
            <div key={item.id || index} className="mb-1">
              <span>{item.qty} x </span>
              <strong>{item.service}</strong>
            </div>
          );
        })}
      </div>
    );
  }, [lineItems]);

  return (
    <WithTooltip
      container={'billing-card'}
      tooltip={<div style={{ alignItems: 'flex-start', display: 'flex', flexDirection: 'column' }}>{items}</div>}
      placement="top"
    >
      <span className="ml-0 text-primary">{title}</span>
    </WithTooltip>
  );
});
